<template>
  <nav class="pix-navbar" :class="environmentClass">
    <div class="pix-navbar__navigation">
      <div class="pix-navbar__logo">
        <router-link tag="button" to="/landing">
          <img :src="jllLogoRoute" alt="JLL Logo" />
        </router-link>
      </div>
      <ul class="pix-navbar__menu">
        <pix-navbar-menu-item v-for="menuItem in filteredNavbarItems" :key="menuItem.label" :menu-item="menuItem" is-first-item />
      </ul>
    </div>
    <div class="pix-navbar__actions">
      <div>
        <pix-signalr-manager />
      </div>
      <div class="pix-navbar__instance">
        <pix-flag :country="instance" />
      </div>
      <button class="pix-navbar__notifications-button" @click="toggleShowNotifications">
        <span class="mdi mdi-bell-outline" />
        <span>{{ numberOfUnreadNotifications }}</span>
      </button>
      <div class="pix-navbar__menu">
        <pix-navbar-menu-item :menu-item="menuItems" :expand-direction="ExpandDirections.Left" is-first-item />
      </div>
      <button class="pix-navbar__login-btn" @click="fnLogout" title="logout">
        <span class="mdi mdi-login-variant" />
      </button>
    </div>
  </nav>
</template>

<script>
import jllLogoRoute from '@/assets/logo-responsive.png';
import pixFlag from '@/components/pix/pixFlag.vue';
import ExpandDirections from './expandDirections.js';
import navbarItems from './navbarItems.js';
import menuItems from './menuItems.js';
import Vue from 'vue';
import pixSignalrManager from '@/components/home/signalr/pixSignalrManager.vue';

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'pix-navbar',

  components: {
    pixFlag,
    pixSignalrManager,
  },

  data() {
    return {
      jllLogoRoute,
      ExpandDirections,
      menuItems,
      routes: navbarItems,
    };
  },

  computed: {
    environmentClass() {
      const classNameByEnvironment = {
        LOCAL: 'pix-navbar--local',
        DEV: 'pix-navbar--dev',
        UAT: 'pix-navbar--uat',
        QA: 'pix-navbar--qa',
      };

      return classNameByEnvironment[this.deployEnvironmentKey];
    },

    filteredNavbarItems() {
      // Filters the links by role and instance
      const filteringFunction = (item) =>
        (item.instances.includes(this.instance) || !item.instances.length) && (!item.roles || (this.$store.getters['authModule/isInRoleArr'](item.roles) && (!item.requiresAuth || (item.requiresAuth && this.isAuthenticated))));

      const filterArray = (arr) => {
        arr.forEach((el) => {
          if (el.children) {
            el.children = filterArray(el.children);
          }
        });

        return arr.filter(filteringFunction);
      };

      return filterArray(_.cloneDeep(this.routes));

      // Alternative method
      // const filterArray = (items) =>
      //   items.filter(filteringFunction).map((el) => {
      //     if (el.children) {
      //       el.children = filterArray(el.children);
      //     }

      //     return el;
      //   });

      // return filterArray(_.cloneDeep(navbarItems));
    },

    ...mapGetters({
      instance: 'authModule/instance',
      isAuthenticated: 'authModule/isAuthenticated',
      deployEnvironmentKey: 'keysModule/getDeployEnvironmentKey',
      chromaticUrl: 'keysModule/getChromaticUrl',
      numberOfUnreadNotifications: 'notificationsModule/getNumberOfUnreadNotifications',
    }),
  },

  watch: {
    chromaticUrl: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const talosLibRoute = this.routes.find((a) => a.label === 'TalosLib');
          if (talosLibRoute?.children) {
            talosLibRoute.children = talosLibRoute.children.filter(this.filterTempRoutes);
            Vue.set(talosLibRoute.children, talosLibRoute.children.length, {
              label: 'Chromatic',
              route: null,
              instances: [],
              roles: '',
              fn() {
                window.open(newValue);
              },
            });
          }
        }
      },
    },
  },

  methods: {
    ...mapActions({
      fnLogout: 'authModule/logout',
    }),

    toggleShowNotifications() {
      this.$store.dispatch('notificationsModule/toggleOpenMenu');
    },

    filterTempRoutes(route) {
      return !route.temp;
    },
  },
};
</script>

<style scoped>
.pix-navbar {
  height: var(--navbar-height);
  padding: 0 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  color: #c0bfbf;
  font-weight: 400;
  font-size: 14px;
  font-family: 'Roboto', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  letter-spacing: 1px;
  background: #222;
}

.pix-navbar.pix-navbar--local {
  background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgb(9 64 234) 100%);
}

.pix-navbar.pix-navbar--dev {
  background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(22, 74, 1, 1) 100%);
}

.pix-navbar.pix-navbar--uat {
  background: yellow;
}

.pix-navbar.pix-navbar--qa {
  background: aqua;
}

.pix-navbar__logo,
.pix-navbar__logo img {
  height: 36px;
}

.pix-navbar__logo button {
  background: none;
  border: none;
}

.pix-navbar__navigation {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.pix-navbar__menu {
  list-style: none;
  white-space: nowrap;
  display: inline-block;
  margin: 0;
  padding: 0;
  height: var(--navbar-height);
  display: flex;
  align-items: center;
}

.pix-navbar__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.pix-navbar__instance {
  flex: 0 0 20px;
  height: 15px;
}

.pix-navbar__notifications-button {
  background: none;
  border: none;
  color: #c0bfbf;
  font-size: 16px;

  display: flex;
  align-items: flex-end;
  gap: 3px;
}

.pix-navbar__login-btn {
  background: none;
  border: none;
  color: #c0bfbf;
  padding: 0;
  font-size: 18px;
}
</style>
